import { render, staticRenderFns } from "./CarreraWrapper.vue?vue&type=template&id=b22dc56a"
import script from "./CarreraWrapper.vue?vue&type=script&lang=js"
export * from "./CarreraWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports